import { IconClose } from '@shared/icons'
import { Button } from '@shared/innmaxUI/Form'
import styled from 'styled-components'

type IMainSidebarProps = {
  visible: boolean
  onClose?: () => void
  headerMoreAction?: React.ReactNode
}

const MainSidebar = (props: React.PropsWithChildren<IMainSidebarProps>) => {
  return props.visible ? (
    <Div visible={props.visible}>
      <div className="flex justify-between items-center mb-15 min-h-[32px] px-[10px]">
        <Button
          type="icon"
          icon={<IconClose color={'#fff'} />}
          onClick={props.onClose}
          className=""
        />
        {props.headerMoreAction}
      </div>
      <div>{props.children}</div>
    </Div>
  ) : null
}

export default MainSidebar

const Div = styled.div<{ visible: boolean }>`
  grid-area: main-sidebar;
  margin-top: 34px;
  margin-right: 10px;
  pointer-events: auto;
  width: ${p => (p.visible ? '250px' : '0px')};
  height: ${p => (p.visible ? 'calc(-64px + -34px + 100vh)' : '0px')};
  word-break: keep-all;
  white-space: nowrap;
  overflow-x: hidden;
  overflow-y: auto;
  background-color: rgba(39, 39, 39, 0.9);
  transition: width 0.3s;
  > * {
    opacity: ${p => (p.visible ? 1 : 0)};
    transition: opacity 0.2s;
  }
`
